/* Predictive search via Shopify's Section Rendering API. */
(() => {
  const init = () => {
    const form = document.querySelector('[data-predictive-search]');
    if (!form || form.dataset.ready) return;
    form.dataset.ready = 1;
    const input = form.querySelector('input[type="search"]');
    const results = document.getElementById(input.getAttribute('aria-controls'));
    let timer, controller;
    const cache = new Map();

    const render = (html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-predictive-results]');
      results.innerHTML = fresh ? fresh.outerHTML : '';
      document.dispatchEvent(new CustomEvent('ns:dom-updated', { detail: results }));
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(async () => {
        if (cache.has(q)) return render(cache.get(q));
        controller?.abort();
        controller = new AbortController();
        results.setAttribute('aria-busy', 'true');
        try {
          const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
          const url = `${base}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,article,page&resources[limit]=6&resources[limit_scope]=each`;
          const html = await fetch(url, { signal: controller.signal }).then((r) => r.text());
          cache.set(q, html);
          render(html);
        } catch (e) { if (e.name !== 'AbortError') results.innerHTML = ''; }
        finally { results.removeAttribute('aria-busy'); }
      }, 220);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
